export default {
  data: {
    eventStatus: {
      0: "Draft",
      1: "Pending review",
      2: "Published",
      3: "Rejected",
      4: "Cancelled",
    },
    eventRegistrationWindowStatus: {
      "-1": "Registration: unknown",
      0: "Registration soon",
      1: "Registration open",
      2: "Registration closed",
    },
    eventScheduleStatus: {
      "-1": "Event: unknown",
      0: "Upcoming",
      1: "In progress",
      2: "Finished",
    },
    depositWorkCategory: {
      0: "Category 0",
      1: "Category 1",
      2: "Category 2",
      3: "Category 3",
      4: "Category 4",
      5: "Category 5",
      6: "Category 6",
      7: "Category 7",
      8: "Category 8",
      9: "Category 9",
      10: "Category 10",
      11: "Category 11",
      12: "Category 12",
      13: "Category 13",
      14: "Category 14",
      15: "Category 15",
      16: "Category 16",
      17: "Category 17",
      18: "Category 18",
      19: "Category 19",
    },
    depositIndustryDirection: {
      0: "Industries of text and meaning",
      1: "Industries of visual image",
      2: "Musical and sound industries",
      3: "Stage and performative industries",
      4: "Digital and interactive industries",
      5: "Screen and audiovisual industries",
      6: "Spatial and object industries",
    },
    depositWorkCategoryMember: {
      LiteraryWork: "Literary work",
      DramaScript: "Drama, script",
      MusicalWork: "Musical work",
      PhonogramRecording: "Phonogram recording",
      AudiovisualWork: "Audiovisual work",
      FineArt: "Fine art",
      Handicraft: "Handicraft, decorative and applied arts",
      PhotographyIllustration: "Photography, illustration",
      DesignLogo: "Design, logo",
      ArchitectureBlueprintPrototype: "Architecture, blueprint, prototype",
      ChoreographyDance: "Choreography, dance",
      DigitalService: "Digital service",
      OnlineCourseEducationalMaterial: "Online course, educational materials",
      ScientificWork: "Scientific work",
      ComputerGraphics3d: "Computer graphics, 3D",
      GameGameDesign: "Game, game design",
      Database: "Database",
      CompositeCollection: "Composite work, collection",
      DerivativeWork: "Derivative work",
      Other: "Other",
    },
    depositIndustryDirectionMember: {
      TextAndMeaningIndustries: "Industries of text and meaning",
      VisualImageIndustries: "Industries of visual image",
      AudioAndSoundIndustries: "Musical and sound industries",
      PerformingArtsIndustries: "Stage and performative industries",
      DigitalInteractiveIndustries: "Digital and interactive industries",
      ScienceAndEducationIndustries: "Screen and audiovisual industries",
      CraftAndAppliedArtsIndustries: "Spatial and object industries",
    },
    depositRecordStatus: {
      "-1": "Draft",
      0: "Draft",
      1: "Preparing to submit",
      2: "Pending moderation",
      3: "Confirmed",
      4: "Rejected",
      5: "Team review",
      6: "Needs revision",
    },
    depositRightsHolderKind: {
      0: "Individual",
      1: "Organization",
    },
    depositAuthorRole: {
      0: "Author",
      1: "Co-author",
    },
  },
}
